<template>
  <div class="corpoConteudoInterno">
    <Topo></Topo>
    <Migalha label="Acesso Restrito"></Migalha>
    <h1 class="text-primary text-xs-center p-b-30 p-t-30">
      <strong>ACESSO RESTRITO</strong>
    </h1>
    <v-layout row wrap>
      <v-flex xs12 sm4></v-flex>
      <v-flex xs12 sm4>
        <loginRestritoForm></loginRestritoForm>
      </v-flex>
      <v-flex xs12 sm4></v-flex>
    </v-layout>
  </div>
</template>
<script>
import loginRestritoForm from "./components/form-login-restrito";
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";
import loginService from "../../services/loginService";

export default {
  name: "loginRestrito",
  components: { /*Componentes utilizados*/
    loginRestritoForm,
    Migalha,
    Topo
  },
  created() /*Metodo de start do componente*/{
    localStorage.removeItem("vuex");
    this.getRedeGoverno();
  },
  data() {//Declaracao de variaveis
    return {};
  },
  methods: {//Declaracao de todos os metodos
    getRedeGoverno() {
      loginService.getRedeGoverno().then(response => { /*resposta do servico*/
          if(!response.data)
            this.$router.push("login");
      });
    }
  }
};
</script>